module.exports = __webpack_public_path__ + "static/img/xlsx1.52064e9c.svg";